import * as React from "react";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";

import { InlineNotification, Toggle } from "carbon-components-react";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import { loadApp } from "underwriter_dashboard/actions";
import Money from "../../Money";
import APIClient from "../../APIClient";
import WorksheetEditor from "../shared/WorksheetEditor";

/* TransactionTermsHurdleEditor */

interface HurdleEditorProps extends HurdleProps {
  loadApp: Function;
  dispatch: any;
}

class TransactionTermsHurdleEditor extends React.Component<HurdleEditorProps, any> {
  componentDidMount() {
    this.state = { loading: false };

    this.getTermsAndSetState();
  }

  getTermsAndSetState = () => {
    const {
      app: { id },
    } = this.props;
    return APIClient.get(`/uw/${id}/transaction_terms`).then((resp: any) => {
      this.setState({
        ...resp,
        loading: false,
      });
    });
  };

  toggleEditing() {
    const {
      app: { id },
      loadApp,
    } = this.props;

    const { editing: editingTransactionTerms } = this.state;

    const shouldReload = editingTransactionTerms === true;

    this.setState(
      prevState => {
        const { interval, editing } = prevState;
        if (interval) {
          clearInterval(interval);
        }
        return {
          interval: editing ? null : setInterval(this.getTermsAndSetState, 5000),
          editing: !editing,
        };
      },
      () => {
        this.getTermsAndSetState().then(() => {
          if (shouldReload) {
            loadApp(id);
          }
        });
      },
    );
  }

  renderOpsOverrideWarning = () => (
    <div>
      <InlineNotification
        hideCloseButton
        lowContrast
        kind="warning"
        notificationType="inline"
        role="alert"
        title="Warning: "
        subtitle="Terms have been updated by ops. Please verify the rate."
      />
      <br />
      <h4>
        Please note that changing terms here does not automatically affect the rate. In particular,
        adjusters for higher loan amounts or lower LTV require further action to be applied. Contact
        capital markets to adjust the rate if needed.
      </h4>
    </div>
  );

  renderProductSelectionWarning = () => (
    <div>
      <h4>
        <strong>Warning:</strong>
        can not edit transaction terms before borrower selects product
      </h4>
      <br />
    </div>
  );

  render = () => {
    if (this.state === null) {
      return null;
    }
    const { base_loan_amount, purchase_price, down_payment, editing, loading } = this.state;
    const { hurdle, onHide, app } = this.props;
    const {
      computed_properties: { ltv },
    } = app;

    const addsUp =
      base_loan_amount &&
      purchase_price &&
      down_payment &&
      Number(base_loan_amount.amount) + Number(down_payment.amount) ===
        Number(purchase_price.amount);
    const color = addsUp ? "black" : "red";

    const opsOverrideText = "Operator Override";
    const isOpsOverride =
      base_loan_amount.source === opsOverrideText ||
      purchase_price.source === opsOverrideText ||
      down_payment.source === opsOverrideText;

    const canEditTransactionTerms = app.product_selection_time != null;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {canEditTransactionTerms && (
          <div
            style={{
              position: "absolute",
              top: "24px",
              left: "310px",
              zIndex: 12,
            }}
          >
            {loading && "Loading"}
            {!loading && (
              <Toggle
                id="toggle-editability-of-transaction-terms"
                toggled={editing}
                onToggle={() => {
                  this.setState({ loading: true });
                  this.toggleEditing();
                }}
                labelText="Enable editing"
                labelA=""
                labelB=""
              />
            )}
          </div>
        )}
        <div style={{ marginBottom: "40px" }} />

        {editing && (
          <WorksheetEditor
            showLoadingModal
            appId={app.id}
            loanFileWsId={app.loan_file_worksheet_id}
            openToWsName="transaction_terms"
          />
        )}
        <Table style={{ color }}>
          <thead>
            <tr>
              <th>Transaction Terms</th>
              <th>Source</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Base Loan Amount</td>
              <td>{base_loan_amount && base_loan_amount.source}</td>
              <td>{base_loan_amount && <Money value={base_loan_amount.amount} />}</td>
            </tr>
            <tr>
              <td>Purchase Price</td>
              <td>{purchase_price && purchase_price.source}</td>
              <td>{purchase_price && <Money value={purchase_price.amount} />}</td>
            </tr>
            <tr>
              <td>Downpayment</td>
              <td>{down_payment && down_payment.source}</td>
              <td>{down_payment && <Money value={down_payment.amount} />}</td>
            </tr>
            <tr>
              <td>LTV</td>
              <td />
              <td>{parseFloat(ltv) * 100}%</td>
            </tr>
          </tbody>
        </Table>
        {!canEditTransactionTerms && this.renderProductSelectionWarning()}
        {isOpsOverride && this.renderOpsOverrideWarning()}
      </HurdleView>
    );
  };
}

const mapDispatchToProps = (dispatch: any) => ({
  loadApp: (appId: number) => loadApp(dispatch, appId),
});

export default connect<any, any, any>(null, mapDispatchToProps)(TransactionTermsHurdleEditor);
